import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Observer } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { MessageService } from './message.service';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class OpenEdgeService extends BaseService {
	responseResults: any[] = [];

	
	constructor(private http: HttpClient, public _messageService: MessageService, private _router: Router) {
		super();
	}

	public getOpenEdgeOrder(orderRefNumber: string) {
		var reqUri = environment.commonApiUrl + 'store/getopenedgeorder?orderRefNumber=' + this.cleanseUrlParam(orderRefNumber);
		return this.http.get<any>(reqUri, super.getHeaders());
	}

	public processOETransaction(payToken: string, key: string, activeInvoice: any) {
		var reqUri = environment.commonApiUrl + 'store/processopenedgepayment?payToken=' + this.cleanseUrlParam(payToken) + '&appKey=' + this.cleanseUrlParam(environment.appToken) + '&key=' + this.cleanseUrlParam(key);
		var body = JSON.stringify(activeInvoice);
		return this.http.post<any>(reqUri, body, super.getHeaders());
	}
}
